const getTimestamp = ({ updatedAt }) =>
  Number.isFinite(updatedAt) ? updatedAt : null;

/**
 * Sort a list with the selected item first, then by most recently updated.
 * Items missing `updatedAt` are placed last, and name is used as a tiebreaker.
 */
export const sortByUpdated = (list, selectedItem) => {
  return [...list].sort((a, b) => {
    if (a.id === selectedItem || b.id === selectedItem) {
      return a.id === selectedItem ? -1 : b.id === selectedItem ? 1 : 0;
    }

    const updatedA = getTimestamp(a);
    const updatedB = getTimestamp(b);

    if (updatedA !== updatedB) {
      if (updatedA === null) return 1;
      if (updatedB === null) return -1;
      return updatedB - updatedA;
    }

    const nameA = (a.name ?? '').toUpperCase();
    const nameB = (b.name ?? '').toUpperCase();

    // Use natural sorting
    return nameA.localeCompare(nameB, undefined, { numeric: true });
  });
};
